import { useApi } from "../../libs/shared/hooks/useApi";
import { GuestPublicContext } from "../types/GuestPublicContext";

export const useGuestReservation = (hostawayReservationId: number) =>
  useApi<GuestPublicContext, undefined>(
    `/v1/guest/reservations/manager/reservation/${hostawayReservationId}`
  );
